import { apiRequest } from "../http";

export const chatV2 = (data: {
  messages: Array<{ role: string; content: string }>;
  userId: string;
  sessionId?: string;
}) =>
  apiRequest<{ reply: string }>("/api/v2/chat", {
    method: "POST",
    body: data,
  });

export const streamChatV2 = async ({
  messages,
  userId,
  sessionId,
  onChunk,
  onDone,
  onError,
}: {
  messages: Array<{ role: string; content: string }>;
  userId: string;
  sessionId?: string;
  onChunk: (chunk: string) => void;
  onDone: (fullResponse: string) => void;
  onError: (error: Error) => void;
}) => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:4000";
  const response = await fetch(`${apiUrl}/api/v2/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ messages, userId, sessionId }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body?.getReader();
  if (!reader) {
    throw new Error("No reader available");
  }

  const decoder = new TextDecoder();
  let fullResponse = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      fullResponse += chunk;
      onChunk(chunk);
    }
    onDone(fullResponse);
  } catch (error) {
    onError(error instanceof Error ? error : new Error(String(error)));
  }
};

export const classifyNote = (text: string) =>
  apiRequest<{ classification: string }>("/api/classify-note", {
    method: "POST",
    body: { text },
  });
